import { computed, inject, provide } from 'vue'
import { useDisplay } from 'vuetify'

const DETAIL_BOX_NARROW = Symbol('detailBoxNarrow')

/**
 * For a host that shows a detail page inside a box of its own (the presentation
 * stage): the page lays out by that box's width, not the screen's. `narrow` is a
 * ref, true while the box is narrower than the screen width at which a detail
 * page splits into two columns.
 *
 * @param {import('vue').Ref<boolean>} narrow
 */
export const provideDetailNarrow = narrow => provide(DETAIL_BOX_NARROW, narrow)

/**
 * Whether a detail page lays out as on a phone: one column, the comments under
 * the content, and the phone padding. The screen decides (Vuetify's `smAndDown`,
 * under 960px) unless a host provided its box (provideDetailNarrow).
 *
 * @returns {import('vue').ComputedRef<boolean>}
 */
export function useDetailNarrow() {
  const box = inject(DETAIL_BOX_NARROW, null)
  const { smAndDown } = useDisplay()

  return computed(() => (box ? box.value : smAndDown.value))
}
